module.exports = __webpack_public_path__ + "img/head.9175ab80.4637b186.png";